import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/pages/Home.vue";
import Locations from "@/components/pages/Locations.vue";
import Portfolio from "@/components/pages/portfolio/Portfolio.vue";

import NewLocation from "@/components/new-location/NewLocation";
import HelpSupport from "@/components/pages/help-and-support/HelpSupport.vue";
import Contact from "@/components/pages/Contact.vue";

import Introduction from "@/components/pages/help-and-support/Introduction.vue";
import KeyFeatures from "@/components/pages/help-and-support/KeyFeatures.vue";
import UserGuide from "@/components/pages/help-and-support/UserGuide.vue";
import Methodology from "@/components/pages/help-and-support/Methodology.vue";
import Faq from "@/components/pages/help-and-support/Faq.vue";
import FurtherResources from "@/components/pages/help-and-support/FurtherResources.vue";
import TermsOfUse from "@/components/pages/help-and-support/TermsOfUse.vue";
import ReleaseNotes from "@/components/pages/help-and-support/ReleaseNotes.vue";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "app",
			default: true, // indicate if it's the default route
			component: Home,
			children: [
				{
					name: "add-new",
					path: "add-new",
					component: NewLocation
				}
			]
		},
		{
			name: "locations",
			path: "/locations",
			component: Locations
		},
		{
			name: "portfolio",
			path: "/portfolio",
			component: Portfolio
		},
		{
			name: "help-and-support",
			path: "/help-and-support",
			component: HelpSupport,
			children: [
				{
					name: "help-and-support-introduction",
					path: "introduction",
					component: Introduction
				},
				{
					name: "help-and-support-key-features",
					path: "key-features",
					component: KeyFeatures
				},
				{
					name: "help-and-support-user-guide",
					path: "user-guide",
					component: UserGuide
				},
				{
					name: "help-and-support-methodology",
					path: "methodology",
					component: Methodology
				},
				{
					name: "help-and-support-faq",
					path: "faq",
					component: Faq
				},
				{
					name: "help-and-support-further-resources",
					path: "further-resources",
					component: FurtherResources
				},
				{
					name: "help-and-support-terms-of-use",
					path: "terms-of-use",
					component: TermsOfUse
				},
				{
					name: "release-notes",
					path: "release-notes",
					component: ReleaseNotes
				}
			]
		},
		{
			name: "contact",
			path: "/contact",
			component: Contact
		}
	]
});
